<template>
<svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 1185 266" style="enable-background:new 0 0 1185 266;" xml:space="preserve">
<path d="M77.5,265c-19.5,0-35.3-15.4-35.3-34.4v-22.1C18,202.7,0,181.3,0,155.9V55.2C0,25.3,24.9,1,55.7,1h154.7
	C241.1,1,266,25.3,266,55.2V156c0,29.9-24.9,54.2-55.7,54.2h-64.7c-2.8,0-5.4,1.4-6.8,3.6c-10.7,17.1-24.2,31.9-40,43.9
	C92.6,262.5,85.2,265,77.5,265L77.5,265z M55.7,27.3c-15.8,0-28.6,12.5-28.6,27.9V156c0,15.3,12.8,27.9,28.6,27.9
	c7.5,0,13.5,5.9,13.5,13.2v33.6c0,4.9,4.3,8,8.2,8c1.7,0,3.3-0.6,4.7-1.7c13.3-10.1,24.6-22.6,33.6-36.9c6.3-10,17.7-16.2,30-16.2
	h64.7c15.8,0,28.6-12.5,28.6-27.9V55.2c0-15.3-12.8-27.9-28.6-27.9H55.7L55.7,27.3z"/>
<g>
	<path d="M298.9,38.3h28.2l24.9,68.8c3.1,9,5.9,18.4,9,27.6h0.9c3.1-9.2,5.8-18.7,8.9-27.6l24.4-68.8h28.2v140.8h-22.9v-64.4
		c0-13,2-31.7,3.2-44.8h-0.9l-11.4,32.7l-23.2,63.2h-14.8l-23.2-63.2l-11.2-32.7h-0.9c1.2,13,3.2,31.8,3.2,44.8v64.4h-22.5V38.3z"/>
	<path d="M443.1,38.3h84.7v21h-59.8v36.1h50.6v21h-50.6v41.7H530v21h-86.9V38.3z"/>
	<path d="M542.8,38.3h25v119.8h58.5v21h-83.4V38.3z"/>
	<path d="M634.7,38.3h37.5c43.1,0,68.6,23.2,68.6,69.8c0,46.6-25.5,70.9-67.3,70.9h-38.8V38.3z M670.6,158.9
		c28.3,0,44.6-16.1,44.6-50.7s-16.3-49.6-44.6-49.6h-10.9v100.3H670.6z"/>
	<path d="M753.1,38.3h84.7v21h-59.8v36.1h50.6v21h-50.6v41.7H840v21h-86.9V38.3z"/>
	<path d="M852.8,38.3h45c28.9,0,50.2,8.9,50.2,34.7c0,13.3-7.2,26.2-19.5,30.5v0.9c15.6,3.5,27,14.4,27,33.4
		c0,28.2-23.1,41.3-54.1,41.3h-48.6V38.3z M895.6,96.5c19.6,0,28-7.7,28-19.9c0-13.6-9.2-18.8-27.5-18.8h-18.3v38.7H895.6z
		 M898.8,159.7c20.7,0,32.2-7.4,32.2-23.2c0-14.8-11.2-21.3-32.2-21.3h-21.1v44.5H898.8z"/>
	<path d="M957.7,108.2c0-45.5,25.4-72.4,62.1-72.4s62.1,27,62.1,72.4c0,45.5-25.4,73.5-62.1,73.5S957.7,153.7,957.7,108.2z
		 M1056.2,108.2c0-31.6-14.3-50.7-36.4-50.7c-22.1,0-36.4,19.1-36.4,50.7s14.3,51.8,36.4,51.8C1041.9,160,1056.2,139.8,1056.2,108.2
		z"/>
	<path d="M1114.2,106.5l-37.5-68.2h27.7l15.7,31.3c3.4,6.5,6.4,13,10.6,21.5h0.9c3.5-8.5,6.4-15.1,9.5-21.5l14.9-31.3h26.5
		l-37.5,69.4l40,71.4h-27.7l-17.2-33.2c-3.6-7.1-7.1-14.3-11.3-22.9h-0.9c-3.7,8.6-7.1,15.8-10.4,22.9l-16.7,33.2h-26.5
		L1114.2,106.5z"/>
</g>
</svg>
</template>
